import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from 'src/stores/RootStore';
import InfoPopup from 'src/components/InfoPopup';
import './styles.css';

/**
 * The "Early check-in discounts and cancellation terms" promo line plus its
 * InfoPopup. Shared between the Classes-tab DateSelector and the check-in
 * suggestion dialog so the wording and popup wiring stay in one place.
 */
const EarlyCheckinPromoLine: React.FC = observer(() => {
  const { studioConfigStore } = useContext(RootStoreContext);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  useEffect(() => {
    if (!studioConfigStore.studioConfigs) {
      studioConfigStore.fetchStudioConfigs();
    }
  }, [studioConfigStore]);

  return (
    <>
      <div className="early-checkin-promo">
        Early check-in discounts and cancellation{' '}
        <button
          type="button"
          className="info-text"
          onClick={(e) => {
            e.stopPropagation();
            setShowInfoPopup(true);
          }}
        >
          terms
        </button>
      </div>
      <InfoPopup
        isOpen={showInfoPopup}
        onClose={() => setShowInfoPopup(false)}
        emailAddress={studioConfigStore.studioConfigs?.emailAddress}
        cancelBeforeHours={studioConfigStore.studioConfigs?.classCancelBeforeHours || 0}
        cancelPenaltyCoins={studioConfigStore.studioConfigs?.classCancelCoins || 0}
      />
    </>
  );
});

export default EarlyCheckinPromoLine;
